//import firebase from 'firebase'
import React from 'react'
import { connect } from "react-redux"
import { withRouter } from 'react-router'
import VideosPageContent from './VideosPageContent'
import { setTitle, fetchVideos, fetchTherapyAreas, fetchTherapyCategories } from "../../actions"
import { fetchParentPatientRecords } from '../../actions/parent'


@connect((store) => {
	return {
		User: store.User.User,
		therapy_areas: store.therapy_areas,
		videos: store.videos,
		patient_records: store.patient_records,
		practice_types: store.practice_types
	}
})
class VideosPage extends React.Component {
	constructor(props) {
		super(props)
		this.search = this.search.bind(this)
		this.videos = this.videos.bind(this)
		this.videoClick = this.videoClick.bind(this)
		this.search = this.search.bind(this)
		this.isOnlyParent = this.isOnlyParent.bind(this);
		this.setup = this.setup.bind(this);
		this.userTypeForProfessionFilter = this.userTypeForProfessionFilter.bind(this);
		this.state = {
			'search': '',
			'records':{},
			'filteredPracticeTypes': [],
			'professionSelection': '',
			'filteredVideos': []
		}
	}

	componentDidUpdate(nextProps, nextState) {
		const { User, practice_types, videos } = this.props;

		if (User.token && User.name != nextProps.User.name) {
			this.setup();
		}

		if (practice_types !== nextProps.practice_types) {
			// console.log('Setup Profession Filter');
			this.userTypeForProfessionFilter();
		}


		if (this.state.filteredPracticeTypes != nextState.filteredPracticeTypes) {
			// console.log('Setup Profession selection');
			this.getProfessionSelection();
		}

		if (videos != nextProps.videos) {
			// console.log('Setup Filtered Videos');
			this.videos();
		}
	}

	componentWillMount() {
		const { User } = this.props;

		if (User.token && User.name != '') {
			this.setup();
		}
	}

	setup() {
		const { dispatch, User } = this.props;
		dispatch(fetchTherapyAreas());
		dispatch(fetchTherapyCategories());
		dispatch(fetchVideos());
		dispatch(setTitle('Videos'));

		if (User.parent) {
			dispatch(fetchParentPatientRecords(User._id))
				.then(patient_records => {
					this.setState({'records': patient_records})
				}).catch(err => {
					console.log(err);
				})
		}
		this.userTypeForProfessionFilter();
		this.getProfessionSelection();
		this.videos();
	}

	search(e) {
		this.setState({
			'search': e.target.value
		})

		this.videos()
	}

	videoClick(video) {
		const { history } = this.props;
		history.push(`/page/videos/${video._id}`)
	}

	userTypeForProfessionFilter(){
		const {User, practice_types} = this.props;

		// IF USER IS ADMIN
		if (User.admin){
			this.setState({
				'filteredPracticeTypes': practice_types
			})
			return
		}

		let pracs = [...User.ownPractices, ...User.therapistPractices, ...User.practices];
		let filterPracticeTypes = [];
		// console.log("pracs: ", pracs);

		// Check and remove duplicates pracs
		pracs = pracs.filter((prac, index, self) => {
			if (prac !== undefined){
				return index === self.findIndex((t) => {
					if (t !== undefined) {
						return t.id === prac.id
					}
				})
			}
		});

		pracs.forEach(prac => {
			if (prac !== undefined) {
				let pracFiltered = practice_types.find(type => {
					if (type !== undefined) {
						return prac.practice_type === type.id;
					}
				});
				filterPracticeTypes.push(pracFiltered);	
			}
		});

		// Check and remove duplicates
		filterPracticeTypes = filterPracticeTypes.filter((prac, index, self) => {
			if (prac !== undefined) {
				return index === self.findIndex((t) => {
					if (t !== undefined) {
						return t.id === prac.id
					}
				});
			}
		});
			
		this.setState({
			filteredPracticeTypes: filterPracticeTypes
		});
	}

	videos() {
		const {
			videos,
			therapy_areas,
			patient_records,
			User
		} = this.props;

		let owner = (User.owner && User.ownPractices.length > 0);
		let parent = User.parent ? User.parent : false;
		let therapist = User.therapist ? User.therapist : false;

		let allVideos = videos;

		let patientVideos = [];
		let patientRecords = {};

		if (owner || therapist){
			patientRecords = Object.values(allVideos).map(function (video) {
				patientVideos.push(video.id)
			});
		} else if(parent){
			patientRecords = Object.values(patient_records).map(function (videoId) {
				Object.keys(videoId.videosCount).forEach(function (v) {
					patientVideos.push(v)
				})
			})
		}

		const { search } = this.state;
		const searchExp = new RegExp(search, 'i')

		let videoss = Object.values(videos).filter(v => patientVideos.indexOf(v._id) !== -1).filter(v => v.name.match(searchExp))

		// console.log(this.props);
		// console.log('Vidoess', videoss);
		// console.log("searchExp", searchExp)
		// let areas = Object.values(therapy_areas).filter(a => a.name.match(searchExp));
		// console.log("Areas", areas)
		let videoIds = [];
		// areas.forEach(function (area) {
		// 	area.videos.forEach(function (video) {
		// 		videoIds.push(video);
		// 	});
		// });
		videoss.forEach(vid => {
			videoIds.push(vid.id)
		})
		// console.log(videoIds);
		this.setState({
			'filteredVideos': Object.values(videoss).filter(v => videoIds.indexOf(v._id) !== -1)
		});
	}

	isOnlyParent() {
		const { User } = this.props;

		return !(User.owner || User.therapist)
	}

	getProfessionSelection() {
		const { User } = this.props;
		// console.log(User);
		// console.log(filteredPracticeTypes);
		let professionSelection = "";
		if (User.ownPractices.length > 0) {
			professionSelection = User.ownPractices[0].practice_type
		} else if (User.therapistPractices.length > 0) {
			professionSelection = User.therapistPractices[0].practice_type
		} else if (User.practices.length > 0) {
			professionSelection = User.practices[0].practice_type
		}
		this.setState({
			professionSelection: professionSelection
		});
	}

	render() {
		const { search, patient_videos, filteredPracticeTypes, professionSelection, filteredVideos } = this.state;
		// console.log(patient_videos)
		return <VideosPageContent 
			isOnlyParent={this.isOnlyParent}
			videoClick={this.videoClick}
			search={search}
			handleSearch={this.search}
			videos={filteredVideos} 
			userType={this.userTypeForProfessionFilter}
			practice_types={filteredPracticeTypes}
			professionSelection={professionSelection}	
			/>
	}
}

export default withRouter(VideosPage);



// WEBPACK FOOTER //
// ./src/components/home/VideosPage.jsx